<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
<!--      <a-form-model-item prop="merchantType" v-if="form.parentId!=='0'">
        <span slot="label" >
          <a-tooltip>
            商户类型<template slot="title">'商户类型'</template>
          </a-tooltip>
        </span>
        <a-select :placeholder="$t('请选择')+'商户类型'" v-model="form.merchantType"  style="width: 100%" allow-clear>
          <a-select-option v-for="(d, index) in this.customDict.MerchantTypeEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
        </a-select>
      </a-form-model-item>-->
<!--      <a-form-model-item prop="parentId" >
        <span slot="label" >
          <a-tooltip>
            父级<template slot="title">'父级'</template>
          </a-tooltip>
        </span>
        <a-select :placeholder="$t('请选择')+'父级'" v-model="form.parentId" :disabled="form.parentId==='0'"  style="width: 100%" allow-clear>
          <a-select-option v-for="(d, index) in this.parentList" :key="index" :value="d.id">{{ d.categoryName }}</a-select-option>
        </a-select>
      </a-form-model-item>-->
      <a-form-model-item prop="categoryName" >
        <span slot="label" >
          <a-tooltip>
            类目名称<template slot="title">'类目名称'</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.categoryName" :maxLength="64" :placeholder="$t('请输入')+'类目名称'" />
      </a-form-model-item>
      <a-form-model-item :label="$t('分类图片')" prop="categoryPic">
        <oss-upload-single :height="100" :width="100"  v-model="form.categoryPic" prefix="goods" type="img"/>
        <span>推荐尺寸 60 x 60</span>
      </a-form-model-item>
      <a-form-model-item prop="marginAmount" >
        <span slot="label" >
          <a-tooltip>
            保证金<template slot="title">保证金</template>
          </a-tooltip>
        </span>
        <a-input-number v-model="form.marginAmount" :maxLength="8" :min="0" :max="99999999" :step="0.01" style="width: 100%"  :placeholder="$t('请输入')+'保证金'"/>
      </a-form-model-item>

      <a-form-model-item prop="alipayMcc" >
        <span slot="label" >
          <a-tooltip>
            支付宝mcc<template slot="title">'支付宝mcc'</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.alipayMcc" :maxLength="8" :placeholder="$t('请输入')+'支付宝mcc'" />
      </a-form-model-item>
      <a-form-model-item prop="wechatPayMcc" >
        <span slot="label" >
          <a-tooltip>
            微信mcc<template slot="title">'微信mcc'</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.wechatPayMcc" :maxLength="8" :placeholder="$t('请输入')+'微信mcc'" />
      </a-form-model-item>
      <a-form-model-item prop="unionPayMcc" >
        <span slot="label" >
          <a-tooltip>
            银联mcc<template slot="title">'银联mcc'</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.unionPayMcc" :maxLength="8" :placeholder="$t('请输入')+'银联mcc'" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            备注<template slot="title">'备注'</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getIndustry, addIndustry, updateIndustry,listIndustry } from '@/api/merchant/industry'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";


export default {
  name: 'CreateForm',
  props: {
    parentList: {
      type: Array,
      default: []
    }
  },
  components: {
    OssUploadSingle,
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        merchantType: 0,
        marginAmount: 0,
        categoryPic: undefined,
        categoryName: null,

        fullName: null,

        categoryCode: null,

        parentId: 0,

        alipayMcc: null,

        wechatPayMcc: null,

        unionPayMcc: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        categoryName: [
          { required: true, message: '类目名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantType: [
          { required: true, message: '商户类型'+this.$t('不能为空'), trigger: 'change' }
        ],
        marginAmount: [
          { required: true, message: '保证金'+this.$t('不能为空'), trigger: 'blur' }
        ],
        parentId: [
          { required: true, message: '父级'+this.$t('不能为空'), trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        merchantType: 0,
        categoryPic: undefined,
        categoryName: null,
        marginAmount: 0,
        fullName: null,
        categoryCode: null,
        parentId: 0,
        alipayMcc: null,
        wechatPayMcc: null,
        unionPayMcc: null,
        createTime: null,
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getIndustry({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateIndustry(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addIndustry(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
